import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/app/src/features/auth/components/AppShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/features/auth/components/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/app/src/shared/providers/ModalProvider.tsx");
